<template>
  <!-- classes stepper-page-container stepper-page are needed for imported stylesheet -->
  <div class="stepper-page-container">
    <v-container :class="{'privatpage':true, 'stepper-page':true, 'stepper-page-wide': isYoligWideScreen }" fluid>
      <div
        v-if="!confirmation"
        id="stepperpageContent"
        :class="showSummaryBox ? '' : 'centered'"
        class="area-content"
      >
        <v-stepper :value="currentStepNumber" alt-labels>
          <!-- v-model="currentStepNumber" needs a setter -->
          <!-- Using editable vstepper-step means no validation before step switch... instead provide own  @click event and css - classes -->
          <div id="custom-header-stepper" class="scroll-up-stepper white">
            <v-stepper-header class="custom-stepper">
              <template v-for="step in allSteps">
                <v-stepper-step
                  ref="'stephead' + step.number"
                  :key="'stepkey' + step.number"
                  :class="{toplabel: step.number % 2 === 0}"
                  :complete="step.complete"
                  :step="step.number"
                >{{ step.title }}</v-stepper-step>

                <v-divider v-if="step.number < 5" :key="'dividerkey' + step.number"/>
              </template>
            </v-stepper-header>

            <v-divider/>
          </div>

          <!-- dynamisch könnte man die Step-Components auch laden<keep-alive>
            <component :is="dynamicComponent"
                       state-path="b" />
          </keep-alive>-->
          <v-stepper-content step="1" class="mb-0 pa-0">
            <privat-step1
                ref="compStep1"
                state-path="b"
                class="privat-step1"
                :hide-next="loadTarifError"
                @step-forward="stepForward"
                @step-back="stepBack"
                @load-tarif-error="onLoadTarifError"
              />
          </v-stepper-content>

          <v-stepper-content step="2" class="mb-0 pa-0">
            <privat-step2
              ref="compStep2"
              :producterror="producterror"
              state-path="b"
              class="privat-step2"
              @producterror="producterror = false"
              @step-forward="stepForward"
              @step-back="stepBack"
            />
          </v-stepper-content>

          <v-stepper-content step="3" class="mb-0 pa-0">
            <privat-step3
              ref="compStep3"
              state-path="b"
              @step-forward="stepForward"
              @step-back="stepBack"
            />
          </v-stepper-content>

          <v-stepper-content step="4" class="mb-0 pa-0">
            <privat-step4
              ref="compStep4"
              state-path="b"
              @step-forward="stepForward"
              @step-back="stepBack"
            />
          </v-stepper-content>

          <v-stepper-content step="5" class="mb-0 pa-0">
            <privat-step5
              ref="compStep5"
              state-path="b"
              @angebot="createPrivatPageAngebot('Angebot', false)"
              @angebotfremd="createPrivatPageAngebot('Angebot', true)"
              @step-forward="stepForward"
              @step-back="stepBack"
              @step-fail="stepFail"
            />
          </v-stepper-content>
        </v-stepper>
      </div>

      <privat-confirm v-if="confirmation" state-path="b"/>

      <div v-if="showSummaryBox" class="area-summary-box">
        <summary-box state-path="b"
         @kurzangebot="createPrivatPageAngebot('Kurzangebot', false)"
         @kurzangebotfremd="createPrivatPageAngebot('Kurzangebot', true)"
         />
      </div>
    </v-container>

    <error-message-display :errors="errorSnackbar"/>

    <v-dialog
      v-model="angebotDialog.show"
      :width="angebotDialog.width"
      :persistent="!angebotDialog.isSuccess && !angebotDialog.isError"
    >
      <confirm ref="confirm"/>
      <angebot-dialog
        :title="angebotDialog.title"
        :success="angebotDialog.isSuccess"
        :error="angebotDialog.isError"
        :reset="true"
        :sus="getSuS"
        :yolig="getYolig"
        @close="angebotDialog.show=false"
        @open-angebot="openAngebot"
        @reset-angebot="confirmResetDialog"
      />
    </v-dialog>
  </div>
</template>

<script>
require("@/assets/css/stepperstyle.css");

import StepperPageMixin from "@/components/privatkundenrechner/StepperPageMixin";
import PrivatStep1 from "@/components/privatkundenrechner/PrivatStep1";
import PrivatStep2 from "@/components/privatkundenrechner/PrivatStep2";
import PrivatStep3 from "@/components/privatkundenrechner/PrivatStep3";
import PrivatStep4 from "@/components/privatkundenrechner/PrivatStep4";
import PrivatStep5 from "@/components/privatkundenrechner/PrivatStep5";
import PrivatConfirm from "@/components/privatkundenrechner/PrivatConfirm";
import AngebotDialog from "@/components/privatkundenrechner/AngebotDialog";
import ErrorMessageDisplay from "@/components/ErrorMessageDisplay";
import ValidationMixin from "@/components/helper/ValidationMixin";
import SummaryBox from "@/components/privatkundenrechner/SummaryBox";
import confirm from "@/components/helper/confirm";

export default {
  name: "PrivatPage",
  components: {
    PrivatStep1,
    PrivatStep2,
    PrivatStep3,
    PrivatStep4,
    PrivatStep5,
    PrivatConfirm,
    ErrorMessageDisplay,
    SummaryBox,
    AngebotDialog,
    confirm
  },
  mixins: [ValidationMixin, StepperPageMixin],
  data() {
    return {
      confirmation: false,
      loadTarifError: false
    };
  },
  computed: {
    showSummaryBox() {
      return this.$vuetify.breakpoint.width > 1200 && !this.confirmation;
    },
    productLine() {
      return this.$store.state.b.productLine;
    },
    getSuS() {
      return this.$store.state.b.sus;
    },
    getYolig() {
      return this.$store.state.b.productLine === 'YOLIG';
    },
    allSteps() {
      return this.$store.state.s.privat.steps;
    },
    currentStepNumber() {
      return this.$store.state.s.privat.activeStepNumber;
    },
    showYoligMatrix() {
      return this.$store.getters.showYoligMatrix('b');
    },
    isYoligWideScreen() {
      return !!(this.$store.getters.activeStepNumberPrivat === 2 && this.$store.getters.showYoligMatrix('b')
        && this.$store.getters.isSusAvailable && !this.$store.state.b.nurnachhaltig);
    }
  },
  watch: {
    currentStepNumber(newStep, oldStep) {
      if (newStep === 4 && oldStep === 3) {
        this.$store.commit('privatCleanupPersonData');
      }
      if (newStep === 5 && oldStep === 4) {
        this.$store.commit('privatCleanupVorverData');
      }
    }
  },
  created() {
    if (this.currentStepNumber === 6) {
      this.confirmation = true;
    }
  },
  beforeDestroy() {
    if (this.currentStepNumber === 6) {
      this.$store.commit("resetSteps", { page: "privat" });
      this.$store.commit("resetAngebotData");
    }
  },
  methods: {
    confirmResetDialog() {
      this.$refs.confirm
        .open("Eingaben zurücksetzen", "Wollen Sie wirklich alle Ihre Eingaben zurücksetzen?", { color: "primary" })
        .then( () => {
          this.resetAngebot();
        });
    },
    resetAngebot() {
      this.$store.dispatch("resetAngebotForm");
      this.angebotDialog.show = false;
      //this.$router.go();
      this.clearValidation(this);
      window.scrollTo(0, 0);
    },
    submitAntrag() {
      console.log("submitAntrag");
      this.angebotDialog.title = "Antrag";
      this.showDialog();
      this.$store
        .dispatch("submitFormular", { statePath: "b", formularType: "Antrag" })
        .then(() => {
          this.angebotDialog.show = false;
          this.stepSuccess("privat", 5, 6);
        })
        .catch(() => {
          this.angebotDialog.isError = true;
        });
    },
    createPrivatPageAngebot(type, createFremdangebot = false) {
      if( createFremdangebot ) {
        const vm = this.$store.state.b.selectedIdentity.vmnr ?? '00000';
        let payload = { b: { fremdangebot: vm + '-' + Date.now() }};
        this.$store.commit("setObject", payload);
      } else {
        this.$store.commit("setObject", {b:{fremdangebot:''}});
      }
      this.createAngebot(type, "b");
    },
    stepBack() {
      this.doPrivatPageStep(this.currentStepNumber, this.currentStepNumber - 1);
    },
    stepFail() {
      window.scrollTo(0, 0);
      this.errorSnackbar.errormessages = ["Bitte bestätigen Sie die rechtzeitige Vorlage der geforderten Dokumente."];
      this.errorSnackbar.displayerrors = true;
    },
    stepForward() {
      this.doPrivatPageStep(this.currentStepNumber, this.currentStepNumber + 1);
    },
    doPrivatPageStep(fromstep, tostep) {
      if (tostep === 6) {
            return this.submitAntrag();
      }
      if (tostep === 4) {
        this.$store.commit("telefonCleanup");
      }
      this.doStep("privat", fromstep, tostep);
    },
    stepSuccess(page, fromstep, tostep) {
      console.log("stepSuccess");
      if (fromstep < tostep) {
        this.$store.commit("setStepComplete", {
          page: "privat",
          stepNumber: this.currentStepNumber
        });
      }
      this.$store.commit("doStepTo", {
        page: "privat",
        stepNumber: tostep
      });
      window.scrollTo(0, 0);
      this.confirmation = this.currentStepNumber === 6;
    },
    onLoadTarifError() {
      console.log("onLoadTarifError");
      this.errorSnackbar.errormessages.push("Keine Verbindung zum Server, Tarife konnten nicht geladen werden, bitte Seite neu laden!");
      this.errorSnackbar.timeout = -1;
      this.errorSnackbar.closebutton = false;
      this.errorSnackbar.displayerrors = true;
      this.loadTarifError = true;
    }
  }
};
</script>
<style>
/* general stepper stylings: see assets/css/stepperstyle */
</style>
